import React from "react";
import { CalenderIcon } from "../Icon";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { FixedAssetRegisterForm } from "../../commonTypes/fixedAssetRegisterTypes";
import moment from "moment";
import { handleDate, reverseDate } from "../../utils/commonFunctions";
type AppProps = {
  fixedAssetRegisterForm: FixedAssetRegisterForm;
  setFixedAssetRegisterForm: React.Dispatch<React.SetStateAction<any>>;
  handleInputDetailsChange: (data: any) => void;
};
const SalesDetails = ({
  fixedAssetRegisterForm,
  setFixedAssetRegisterForm,
  handleInputDetailsChange,
}: AppProps) => {
  return (
    <>
      <h6>SALES DETAILS</h6>
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Item Name</label>
            <div>
              <input
                name="item_name"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.sales_details?.item_name}
                onChange={(e) =>
                  setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
                    return {
                      ...prv,
                      sales_details: {
                        ...prv.sales_details,
                        item_name: e.target.value,
                      },
                    };
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Customer Name</label>
            <div>
              <input
                name="customer_name"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.sales_details?.customer_name}
                onChange={(e) =>
                  setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
                    return {
                      ...prv,
                      sales_details: {
                        ...prv.sales_details,
                        customer_name: e.target.value,
                      },
                    };
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>

      {/* ////row 2 */}
      <div className="row">
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Invoice Number</label>
            <div>
              <input
                name="invoice_number"
                type="text"
                className={`form-control`}
                value={fixedAssetRegisterForm?.sales_details?.invoice_number}
                onChange={(e) =>
                  setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
                    return {
                      ...prv,
                      sales_details: {
                        ...prv.sales_details,
                        invoice_number: e.target.value,
                      },
                    };
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Invoice Date</label>
            <div>
              <div>
                <div className="d-flex flex-row position-relative">
                  <div className="date-picker-wraper mr-0 w-100">
                    <Label className="mr-0 w-100">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={
                          fixedAssetRegisterForm?.sales_details?.invoice_date
                            ? new Date(
                                moment(
                                  `${reverseDate(
                                    fixedAssetRegisterForm?.sales_details
                                      ?.invoice_date
                                  )}T00:00:00`,
                                  "YYYY-MM-DD"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        onChange={(e: any) => {
                          let datePut = handleDate(
                            moment(e).format("YYYY-MM-DD")
                          );

                          setFixedAssetRegisterForm({
                            ...fixedAssetRegisterForm,
                            sales_details: {
                              ...fixedAssetRegisterForm?.sales_details,
                              invoice_date: datePut?.length
                                ? reverseDate(datePut)
                                : null,
                            },
                          });
                        }}
                        fixedHeight
                        showMonthDropdown
                        showYearDropdown
                        //   disabled={!isEdit}
                        name="date_of_birth"
                        placeholderText="Select"
                        className="form-control"
                      />
                      <span
                        className="calender-icon"
                        style={{
                          right: "20px",
                          top: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="clientName">Total Amount</label>
            <div>
              <input
                name="sales_total_amount"
                type="number"
                className={`form-control`}
                value={fixedAssetRegisterForm?.sales_details?.total_amount}
                onWheel={(event) => event.currentTarget.blur()}
                onChange={(e) =>
                  setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
                    return {
                      ...prv,
                      sales_details: {
                        ...prv.sales_details,
                        total_amount: e.target.value,
                      },
                    };
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesDetails;
